"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StickyComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _reactSticky = require("react-sticky");
var _storeProvider = _interopRequireWildcard(require("./../util/storeProvider"));
var _ScrollDownToContinueComponent = _interopRequireDefault(require("./ScrollDownToContinueComponent"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class StickyComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCartButtonVisible: false,
      doSticky: true
    };
    this.handleScrollOrSize = this.handleScrollOrSize.bind(this);
    this.onClickScrollDownToCartHandler = this.onClickScrollDownToCartHandler.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollOrSize);
    window.addEventListener('resize', this.handleScrollOrSize);
    this.handleScrollOrSize();
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollOrSize);
    window.removeEventListener('resize', this.handleScrollOrSize);
  }
  handleScrollOrSize(event) {
    if (event) {
      event.preventDefault();
    }
    let el = this.props.continueButtonDiv.current;
    if (el) {
      let top = el.offsetTop,
        left = el.offsetLeft;
      const width = el.offsetWidth,
        height = el.offsetHeight;
      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }
      const tolerance = 1;
      const isCartButtonVisible = top >= window.pageYOffset && left >= window.pageXOffset && top + height - tolerance <= window.pageYOffset + window.innerHeight && left + width <= window.pageXOffset + window.innerWidth;
      const doSticky = window.innerWidth > 1199;
      if (isCartButtonVisible !== this.state.isCartButtonVisible || doSticky !== this.state.doSticky) {
        this.setState({
          isCartButtonVisible: isCartButtonVisible,
          doSticky: doSticky
        });
      }
    }
  }
  onClickScrollDownToCartHandler(event) {
    event.preventDefault();
    const btn = this.props.continueButtonDiv || false;
    if (btn && btn.current) {
      btn.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }
  }
  render() {
    if (!this.state.doSticky) {
      return /*#__PURE__*/React.createElement("div", {
        className: "card ux-card card-block"
      }, this.props.children);
    }
    return /*#__PURE__*/React.createElement(_reactSticky.Sticky, {
      relative: false
    }, ({
      style
    }) => /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "card ux-card card-block"
    }, this.props.children, !this.state.isCartButtonVisible && /*#__PURE__*/React.createElement(_ScrollDownToContinueComponent.default, {
      dataEid: this.context.store.getEid('ordersummary', 'scrolldown-arrow', 'click'),
      text: this.props.text,
      action: this.onClickScrollDownToCartHandler
    }))));
  }
}
exports.StickyComponent = StickyComponent;
StickyComponent.contextType = _storeProvider.default;
StickyComponent.propTypes = {
  text: _propTypes.default.string.isRequired,
  continueButtonDiv: _propTypes.default.object.isRequired,
  children: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _storeProvider.provideContext)(StickyComponent);